import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=7080d36b&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=7080d36b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7080d36b",
  null
  
)

export default component.exports